export const CHANGE_FORM = "passwordUpdate/CHANGE_FORM";
export const SET_ERRORS = "passwordUpdate/SET_ERRORS";
export const INIT = "passwordUpdate/INIT";

export const changeForm = (key, value) => ({
  type: CHANGE_FORM,
  key,
  value
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

export const init = () => ({
  type: INIT
});

const initialState = {
  currentPassword: "",
  password: "",
  passwordConfirmation: "",
  errors: []
};

const passwordUpdate = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_FORM: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    case INIT: {
      return initialState;
    }
    default:
      return state;
  }
};

export default passwordUpdate;



// WEBPACK FOOTER //
// ./src/redux/modules/passwordUpdate.js